/**
 * RTWO Event Bus — Retry Manager Service
 */

import { EVENT_BUS_SERVICE_IDS } from '../domain-models';
import type { DeliveryId } from '../domain-models';
import type { IRetryManagerService, RetryResult } from '../service-interfaces';
import type { EngineSourceAdapterRegistry } from '../registry/adapter-registries';
import { BaseEBusService, type EBusServiceContext } from './base-ebus-service';

const MAX_RETRY_LIMIT = 3;

export class RetryManagerService extends BaseEBusService implements IRetryManagerService {
  readonly serviceId = EVENT_BUS_SERVICE_IDS.RETRY_MANAGER;
  readonly serviceName = 'Retry Manager';
  readonly description =
    'Manages retry logic for failed deliveries. No retries until real event sources connect.';
  readonly integrations = ['Delivery Engine', 'Dead Letter Queue', 'Event Registry'];
  readonly requiresRealEventSources = true;

  constructor(
    context: EBusServiceContext,
    private readonly engineSourceRegistry: EngineSourceAdapterRegistry
  ) {
    super(context);
  }

  async retryDelivery(_deliveryId: DeliveryId): Promise<RetryResult> {
    if (!this.engineSourceRegistry.isConfigured()) {
      return {
        success: false,
        retryCount: 0,
        error:
          'Retry Manager Not Active — Cannot retry deliveries until real event sources are connected.',
        isPlaceholder: true,
        source: 'Event Bus — Retry Manager Not Active',
      };
    }

    return {
      success: false,
      retryCount: 0,
      error:
        'Retry Manager Not Active — Cannot retry deliveries until real event sources are connected.',
      isPlaceholder: true,
      source: 'Event Bus — Retry Manager Not Active',
    };
  }

  getRetryCount(_deliveryId: DeliveryId): 0 {
    return 0;
  }

  getTotalRetryCount(): 0 {
    return 0;
  }

  getMaxRetryLimit(): number {
    return MAX_RETRY_LIMIT;
  }
}
